import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { MonthlyReportListItem } from 'components/List'
import { useReportedMonths, useReportedYears } from 'hooks/revenue'
import { StoreType } from 'types/store'
import { CautionCard } from 'components/Card'

const MonthlyReportList: FC = () => {
  const store: StoreType = useSelector((state: State) => state.store)

  // 管理画面を開設した月の翌月以降から、先月までを表示する
  const months = useReportedMonths(store.created_at)
  const years = useReportedYears(months)

  return (
    <ul className={styles.monthlyReport}>
      {years.length > 0 ? (
        years.map((year) => {
          const monthsOfTheYear = months.filter((month) => month.getFullYear() === year)
          return <MonthlyReportListItem key={year} months={monthsOfTheYear} year={year} />
        })
      ) : (
        <CautionCard caution={'発行済の売上レポートがまだありません。'} size={'small'} />
      )}
    </ul>
  )
}

export default MonthlyReportList
